angular.module('app.api').factory('EmployersApi', [
  'api',
  function EmployersApi(api) {
    const employersApi = {
      getAllEmployers: payload => {
        return api.get(`employers`, {params: payload})
      },
      createEmployer: payload => {
        return api.post(`employers`, payload)
      },
      getEmployerById: id => {
        return api.get(`employers/${id}`)
      },

      updateEmployerById: (id, payload) => {
        return api.put(`employers/${id}`, payload)
      },
      deleteEmployerById: id => {
        return api.delete(`employers/${id}`)
      },

      getEmployerLogoByID: id => {
        return api.get(`employers/${id}/logo`)
      },
      uploadEmployerLogo: (id, payload) => {
        return api.post(`employers/${id}/logo`, payload, {
          headers: {'Content-Type': undefined},
        })
      },
      getEmployerListing: payload => {
        return api.get(`listings/employer`, {params: payload})
      },
      updateEmployerAssignedAgent: payload => {
        return api.put(`bulk/employers/agent`, payload)
      },
    }
    return employersApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/employers-listing/employers.api.js